import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';
import { ConversationThreadMessageArray } from '@models/domain/conversation.thread.message';

export interface IConversationHistoryialogModel {
    title: string;
    subTitle: string;
    message: string;
    conversationMessages: ConversationThreadMessageArray;
}


@Component({
    selector: 'conversationhistory-dialog',
    styleUrls: ['./conversation.history.dialog.css'],
    templateUrl: './conversation.history.dialog.html'
})
export class ConversationHistoryDialog extends DialogComponent<IConversationHistoryialogModel, boolean> implements IConversationHistoryialogModel, OnInit {

    title: string;
    subTitle: string;
    message: string;
    conversationMessages: ConversationThreadMessageArray;

    constructor(dialogService: DialogService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

}
